var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4581_5748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8365 14.1834C10.4345 15.204 7.62017 16.6926 5.85854 18.4368L5.78076 18.5142C6.2492 18.957 6.76286 19.353 7.31813 19.6896L7.4375 19.5438C7.91859 18.957 8.43407 18.39 8.97122 17.8554C10.4127 16.4208 12.0623 15.1788 13.8383 14.1816L13.8365 14.1834Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 12.6714C3.13467 14.4912 3.81112 16.1598 4.8728 17.517L4.92163 17.4684C6.01226 16.3938 7.43206 15.4164 9.14483 14.565C10.646 13.818 12.3697 13.1772 14.2272 12.6714H2.99902Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92263 5.1924C12.9667 8.2218 16.7974 10.2252 20.9989 10.9848C20.4925 6.4938 16.6654 3 12.0153 3C10.7872 3 9.61701 3.2448 8.54803 3.6858C8.98213 4.2078 9.44518 4.7154 9.92263 5.1924Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85854 5.56319C7.62017 7.30919 10.4345 8.79599 13.8365 9.81839C12.0605 8.81939 10.4109 7.57919 8.96942 6.14459C8.43407 5.61179 7.91859 5.04479 7.43569 4.45619L7.31632 4.31039C6.76106 4.64699 6.2474 5.04299 5.78076 5.48579L5.85854 5.56319Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92263 18.8076C9.44338 19.2846 8.98033 19.7922 8.54803 20.3142C9.61521 20.7552 10.7872 21 12.0153 21C16.6654 21 20.4925 17.5062 21.0007 13.0134C16.7992 13.773 12.9685 15.7764 9.92443 18.8058L9.92263 18.8076Z",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14483 9.43499C7.43206 8.58359 6.01226 7.60619 4.92163 6.53159L4.8728 6.48299C3.81112 7.84019 3.13467 9.50879 2.99902 11.3286H14.2254C12.3679 10.8228 10.646 10.182 9.14303 9.43319L9.14483 9.43499Z",
    fill: "#141416"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4581_5748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.edd1b66cbdbfab8c210792090dccd20c.svg";
export { ForwardRef as ReactComponent };